import styles from './mobile.module.scss';
import { VNode, h } from 'vue';
import { PhiLogoWithlabel } from '../../components/phi-logo-with-label';
import { utility } from '@phi/components';
import { Figure } from './figure';

export function Mobile(light: boolean, slot: () => VNode) {
    return h('div', {
        class: [
            utility.p_3,
            styles.mobile,
        ]
    }, [
        h('a', {
            href: 'https://phi3d.com',
            target: '_blank',
            class: utility.unstyled,
        }, PhiLogoWithlabel(light)),

        h('div', { class: styles.figure }, Figure()),

        h('div', { id: 'register-form', class: styles.slot }, slot()),
    ]);
}
